import { ActiveProduct } from "../models/common-product.model";
import { PRODUCT_NAME } from "../name/name.library";

export const getProductsName = (products) => {
	if (products.mobile) {
		return PRODUCT_NAME.mobile;
	} else if (products.orderSIM) {
		return PRODUCT_NAME.orderSIM;
	} else if (products.orderESIM) {
		return PRODUCT_NAME.orderESIM;
	} else if (products.authenticatedOrderSIM) {
		return PRODUCT_NAME.authenticatedOrderSIM;
	} else if (products.authenticatedOrdereSIM) {
		return PRODUCT_NAME.authenticatedOrdereSIM;
	} else if (products.internet) {
		return PRODUCT_NAME.internet;
	} else if (products.energy) {
		return PRODUCT_NAME.energy;
	}
};

export const getActiveProducts = (currentProuct: string): ActiveProduct => {
	currentProuct = currentProuct?.toLowerCase();
	return {
		isInternet: currentProuct === PRODUCT_NAME.internet,
		isMobile: currentProuct === PRODUCT_NAME.mobile,
		isOrderSIM: currentProuct === PRODUCT_NAME.orderSIM,
		isOrderESIM: currentProuct === PRODUCT_NAME.orderESIM,
		isAuthenticatedOrderSIM: currentProuct === PRODUCT_NAME.authenticatedOrderSIM,
		isAuthenticatedOrdereSIM: currentProuct === PRODUCT_NAME.authenticatedOrdereSIM,
		isEnergy: currentProuct === PRODUCT_NAME.energy,
	};
};
export const isInternet = (currentProuct: string): boolean =>
	currentProuct?.toLowerCase() === PRODUCT_NAME.internet;
export const isMobile = (currentProuct: string): boolean =>
	currentProuct?.toLowerCase() === PRODUCT_NAME.mobile;
export const isOrderSIM = (currentProuct: string): boolean =>
	currentProuct?.toLowerCase() === PRODUCT_NAME.orderSIM;
export const isOrderESIM = (currentProuct: string): boolean =>
	currentProuct?.toLowerCase() === PRODUCT_NAME.orderESIM;
export const isAuthenticatedOrderSIM = (currentProuct: string): boolean =>
	currentProuct?.toLowerCase() === PRODUCT_NAME.authenticatedOrderSIM;
export const isAuthenticatedOrdereSIM = (currentProuct: string): boolean =>
	currentProuct?.toLowerCase() === PRODUCT_NAME.authenticatedOrdereSIM;
export const isEnergy = (currentProuct: string): boolean =>
	currentProuct?.toLowerCase() === PRODUCT_NAME.energy;
